var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.701,47.436c-0.157-0.639-0.619-1.16-1.235-1.393l-14.441-5.456l10.417-14.352c0.384-0.528,0.485-1.209,0.273-1.826 c-0.213-0.616-0.712-1.091-1.339-1.271l-11.991-3.45c-0.901-0.26-1.869,0.146-2.315,0.976L31.479,44.118 c-0.274,0.51-0.313,1.114-0.107,1.656c0.206,0.542,0.636,0.967,1.18,1.167l14.668,5.387l-9.829,21.221 c-0.417,0.9-0.111,1.97,0.718,2.514c0.336,0.22,0.717,0.327,1.096,0.327c0.555,0,1.104-0.23,1.495-0.671l23.553-26.476 C64.69,48.751,64.858,48.075,64.701,47.436z M46.712,62.943l5.05-10.903c0.235-0.508,0.247-1.09,0.033-1.605 c-0.214-0.517-0.634-0.92-1.158-1.112L36.093,43.98l10.738-20.001l7.698,2.215L44.248,40.357c-0.366,0.504-0.476,1.151-0.297,1.749 c0.179,0.597,0.626,1.077,1.209,1.297l14.172,5.354L46.712,62.943z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.62793e260a136d0bc81233c1c79e7b38.svg";
export { ForwardRef as ReactComponent };